<template>
  <div style="background-color: #edeff3;">
    <!-- ============= 顶部背景图 ============= -->
    <div>
      <img src="../../assets/images/about/recruitbanner.png" style="width: 100%;display: block">
    </div>
    <div class="recruit" id="recruit">
      <div class="recruit-div-left">
        <table class="recruit-table" cellspacing="0">
          <tr>
            <td class="recruitTableTb" :class="{tdBackground:activeName==='announcement'}" name="announcement" @click="recruitTabs('announcement')">社会招聘公告</td>
          </tr>
        </table>
      </div>
            <div class="recruit-div-right" v-if="activeName==='announcement'">
              <div class="recruit-div">
                <p style="font-weight: 600;height: 28px;">社会招聘公告</p>
              </div>
              <!--    分割线   -->
              <!--              <div class="recruit-border">-->

              <!--              </div>-->
              <div class="recruit-div">
                <p class="recruit-div-p">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中颖电子股份有限公司(以下简称“中颖电子”或“公司”)成立于1994年，自2002年起专注于自主品牌的芯片设计及销售，是创业板上市公司（股票代码：中颖电子300327）。公司总部位于上海，在西安、合肥、深圳及香港等地设有分、子公司。公司以设计和销售MCU产品为起步，2022年的销售额为人民币16亿元,目前是国内家电主控、电动自行车电机控制及锂电池管理芯片等多领域的优势厂商，客户主要集中在国内的大品牌客户。
<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中颖电子的产品涵盖家电主控、电机控制、智能家居、汽车电子、锂电池管理、智能电表、无线医疗、键盘及鼠标等多领域终端的应用IC,公司在数模混合电路设计、电磁兼容及产品的可靠性等方面的设计技术处于业界领先水平。控股子公司芯颖科技则专注于设计AMOLED显示驱动芯片。中颖电子以芯片国产替代为起点，逐步发展壮大，目前在多个领域正积极进军海外市场，规划建立海外研发及销售据点。
<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IC设计企业是人才密集型企业，公司汇聚了400+产业菁英,硕、博士超过1/3。公司以永续发展的理念，构建专业经理人平台，给员工充分的发展空间，以发展成为10亿美元以上年收入的国际级芯片设计企业为中期目标。
<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在新产品线的投资规划上，公司积极布局智能汽车电子、电源管理、工业物联网及机器人电机控制芯片等极具前瞻性、未来性的新兴热门领域，发展空间广阔。 
<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;现面向社会诚招IC数字电路设计工程师、IC模拟电路设计工程师、IC数字电路验证工程师、IC系统应用工程师等岗位优秀人才，简历投递邮箱：hr@sinowealth.com
</p>
<span style="font-size:18px;"><b>《招聘声明》</b></span><br>
1、公司正规招聘不收取任何费用<br>
全过程零收费：本公司在招聘的任何阶段，包括但不限于简历投递、面试筛选、测评环节、入职前培训以及发放工作服等，绝不会向候选人收取任何形式的费用（测评费、培训费、咨询费等等）。无论是现金支付、线上转账，还是以押金等名义要求候选人缴纳款项，均非本公司行为。招聘过程也没有下载手机APP或者登入微信公众号等引入私域的注册登入环节。<br>
2、认准官方渠道确认信息<br>
官方网站：<a href="https://www.sinowealth.com">https://www.sinowealth.com</a><br>
官方电话：021-61219988<br>
面试沟通邮箱：hr@sinowealth.com/jianli@sinowealth.com（非中颖电子sinowealth.com域名邮箱皆为仿冒）<br>
若候选人对招聘事宜有任何疑问，可拨打该官方电话进行咨询核实。如接到自称公司招聘人员但号码非官方电话的来电，并涉及收费要求，请立即拒绝，并及时向招聘平台或相关执法部门举报。
              </div>
            </div>
      <div style="clear:both"></div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "demo3",
        data() {
            return {
                activeName: 'announcement'
            }
        },
        methods: {
            recruitTabs (tabName) {
                this.activeName = tabName
            },
            handleClick(tab, event) {
                console.log(tab, event);
            }
        }
    }

</script>
<style >
.recruit{  margin: 0 auto;  width: 75%;background-color: #fff;}
.recruit-div{line-height: 40px;height: auto;overflow:hidden;}
.recruit-div-left{float: left;line-height: 40px;height: 100%;width: 180px;margin: 0;}
.recruit-div-right{float: left;width: calc(100% - 400px);margin-left: -14px;padding-left: 30px;border-left: 1px solid #4a90e2;transition:opacity 3s;
  animation:bounce-in 1s;
}
@keyframes bounce-in{
  0%{transform:scale(0);}
  100%{transform:scale(1);}
}
.recruit-border{margin-bottom: 16px;border:1px solid #4A90E2}
.recruit-div-p{margin: 0;font-size: 16px;line-height: 40px;}
.recruit-table{width: 100%;}
.recruit-table .tdBackground {background: url("../../assets/images/about/xuanzhong.png")no-repeat;background-size: 100% 60px;}
.recruitTableTb{width: 25%;height: 60px;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/pages/about/join_us.vue